import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  grid:{
    marginTop:10,
    marginBottom:10,
    marginLeft: 20,
  },
  button:{
    marginRight:20,
    cursor: 'pointer',
  },
  media:{
    height:396,
    paddingTop: '56,25%',
  },
  RightTab:{
    borderStyle:'outset',
    borderWidth:'thin',
    borderBottomWidth:'inherit',
    borderRightWidth:'inherit'
  },
  LeftTab:{
    borderStyle:'outset',
    borderWidth:'thin',
    borderBottomWidth:'inherit',
    borderRightWidth:'inherit',
    borderLeftWidth: 'inherit',
  },
  padding: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  metric:{
    paddingLeft:8,
  },
  markerIcon:{
    height:30,
    width:30,
    position:'absolute',
    top:-15,
    left:-15,
  },
  mapView:{
    height: '56.5vh',
    width: '100%',
  }
}));
